// filepath: apps/web/src/features/directory/qualifications/QualificationsRoute.tsx
//
// FR-UI-DIR-1 AC-8 — route shell for /qualifications/:personId.

import React from "react";
import { QualificationsPage } from "./QualificationsPage";

export interface QualificationsRouteProps {
  personId: string;
}

export function QualificationsRoute({
  personId,
}: QualificationsRouteProps): React.ReactElement {
  return <QualificationsPage personId={personId} />;
}
